var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1656 7.43401C14.3156 7.58403 14.3998 7.78748 14.3998 7.99961C14.3998 8.21174 14.3156 8.41519 14.1656 8.56521L8.56561 14.1652C8.41558 14.3152 8.21214 14.3994 8.00001 14.3994C7.78788 14.3994 7.58443 14.3152 7.43441 14.1652L1.83441 8.56521C1.76001 8.49102 1.701 8.40286 1.66078 8.3058C1.62055 8.20873 1.5999 8.10468 1.60001 7.99961V3.99961C1.60001 3.36309 1.85286 2.75264 2.30295 2.30255C2.75304 1.85247 3.36349 1.59961 4.00001 1.59961H8.00001C8.20481 1.59961 8.40961 1.67801 8.56561 1.83401L14.1656 7.43401ZM4.00001 4.79961C4.21218 4.79961 4.41566 4.71532 4.56569 4.56529C4.71572 4.41527 4.80001 4.21178 4.80001 3.99961C4.80001 3.78744 4.71572 3.58395 4.56569 3.43392C4.41566 3.28389 4.21218 3.19961 4.00001 3.19961C3.78783 3.19961 3.58435 3.28389 3.43432 3.43392C3.28429 3.58395 3.20001 3.78744 3.20001 3.99961C3.20001 4.21178 3.28429 4.41527 3.43432 4.56529C3.58435 4.71532 3.78783 4.79961 4.00001 4.79961Z",
    fill: "#9CA2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon-tag.c83923e7.svg";
export { ForwardRef as ReactComponent };